import { useSelector } from 'react-redux'
import { useDomainStorage } from '../../../utility/hooks/useDomainStorage'
import { leaveViewAsUser } from '../../../utility/impersonationSession'
import ImpersonationBanner from './ImpersonationBanner'

// Mounted once in src/index.js; claims come from the decoded access token in auth.userData.
const ImpersonationBannerContainer = () => {
  const claims = useSelector((state) => state?.auth?.userData)
  const domainStorage = useDomainStorage()
  return <ImpersonationBanner claims={claims} onExit={() => leaveViewAsUser(domainStorage)} />
}

export default ImpersonationBannerContainer
